export interface ReportingCycle {
  id: number;
  companyId: number;
  year: number;
  cycle: ReportingCycleEnum;
  created: string;
  modified: string;
}

export interface CreateReportingCyclePayload {
  companyId: number;
  year: number;
  cycle: ReportingCycleEnum;
}

export interface UpdateReportingCyclePayload {
  id: number;
  companyId: number;
  year: number;
  cycle: ReportingCycleEnum;
}

export enum ReportingCycleEnum {
  QUARTERLY = 0,
  YEARLY = 1,
  MONTHLY = 2,
}
